import './Filters.css'

function Filters({ filters, flags, departments, reporters, onFilterChange, onRemoveFilter, onClearAll }) {
  const categories = [...new Set(flags.map(f => f.category))]

  const activeFilters = []
  if (filters.status !== 'all') activeFilters.push({ key: 'status', value: filters.status })
  if (filters.severity !== 'all') activeFilters.push({ key: 'severity', value: filters.severity })
  if (filters.category !== 'all') activeFilters.push({ key: 'category', value: filters.category })
  if (filters.department !== 'all') activeFilters.push({ key: 'department', value: filters.department })
  if (filters.reporter !== 'all') activeFilters.push({ key: 'reporter', value: filters.reporter })

  const formatCategory = (cat) => {
    return cat.split('_').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }

  const getReporterLabel = (value) => {
    if (value === 'anonymous') return 'Anonymous'
    if (value === 'named') return 'Named'
    const reporter = reporters.find(r => r.userId === value)
    return reporter ? `${reporter.userName || reporter.userEmail} (${reporter.flagCount})` : value
  }

  return (
    <div className="filters-section">
      <div className="filters-row">
        <div className="filter-group">
          <label>Status</label>
          <select 
            value={filters.status} 
            onChange={(e) => onFilterChange('status', e.target.value)}
          >
            <option value="all">All Statuses</option>
            <option value="new">New</option>
            <option value="open">Open</option>
            <option value="under_review">Under Review</option>
            <option value="in-progress">In Progress</option>
            <option value="resolved">Resolved</option>
            <option value="closed">Closed</option>
          </select>
        </div>
        <div className="filter-group">
          <label>Severity</label>
          <select 
            value={filters.severity} 
            onChange={(e) => onFilterChange('severity', e.target.value)}
          >
            <option value="all">All Severities</option>
            <option value="high">High</option>
            <option value="medium">Medium</option>
            <option value="low">Low</option>
          </select>
        </div>
        <div className="filter-group">
          <label>Category</label>
          <select 
            value={filters.category} 
            onChange={(e) => onFilterChange('category', e.target.value)}
          >
            <option value="all">All Categories</option>
            {categories.map(cat => (
              <option key={cat} value={cat}>{formatCategory(cat)}</option>
            ))}
          </select>
        </div>
        <div className="filter-group">
          <label>Department</label>
          <select 
            value={filters.department} 
            onChange={(e) => onFilterChange('department', e.target.value)}
          >
            <option value="all">All Departments</option>
            {departments.map(dept => (
              <option key={dept} value={dept}>{dept}</option>
            ))}
          </select>
        </div>
        <div className="filter-group">
          <label>Reporter</label>
          <select 
            value={filters.reporter} 
            onChange={(e) => onFilterChange('reporter', e.target.value)}
          >
            <option value="all">All Reporters</option>
            <option value="named">Named Only</option>
            <option value="anonymous">Anonymous Only</option>
            {reporters.filter(r => !r.isAnonymous && r.flagCount > 1).map(r => (
              <option key={r.userId} value={r.userId}>
                {r.userName || r.userEmail} ({r.flagCount})
              </option>
            ))}
          </select>
        </div>
      </div>

      {activeFilters.length > 0 && (
        <div className="active-filters">
          {activeFilters.map(filter => (
            <div key={filter.key} className="filter-badge">
              {filter.key}: {filter.key === 'reporter' 
                ? getReporterLabel(filter.value)
                : filter.value}
              <button onClick={() => onRemoveFilter(filter.key)}>×</button>
            </div>
          ))}
          <button className="clear-filters-btn" onClick={onClearAll}>
            Clear all
          </button>
        </div>
      )}
    </div>
  )
}

export default Filters

